import { objectToCamelCase, objectToSnakeCase } from '../../../../../../../libs/format';

export function interactionToCamelCase(interaction) {
  return objectToCamelCase(interaction);
}

export function interactionToSnakeCase(interaction) {
  return objectToSnakeCase(interaction);
}
